import React from 'react';

import MultilineText from '../multilinetext/MultilineText';

interface IOwnProps {
    text: string;
    readMoreCutoffLength: number;
    readMoreText?: string;
    readLessText?: string;
}

interface IOwnState {
    isExpanded: boolean;
}

type Props = IOwnProps;

const summarize = (text: string, maxLength: number) => {
    const stringBuilder = new Array<string>();
    let length = 0;

    for (const word of text.split(' ')) {
        if (length + word.length + (length === 0 ? 0 : 1) > maxLength) {
            // Addition of the current word will break the max length, so we're done
            break;
        }

        stringBuilder.push(word);
        length += word.length + (length === 0 ? 0 : 1);
    }

    return stringBuilder.join(' ');
}

class ReadMore extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isExpanded: false
        }
    }

    public render() {
        if (!this.props.text || this.props.text.length <= this.props.readMoreCutoffLength) {
            return this.props.text;
        }

        return this.state.isExpanded
            ? <React.Fragment>
                <MultilineText text={this.props.text} /> <span className="link pointer" onClick={this.toggleExpanded}>{this.props.readLessText || 'Læs mindre'}</span>
            </React.Fragment>
            : <React.Fragment>
                {summarize(this.props.text, this.props.readMoreCutoffLength)}&hellip; <span className="link pointer" onClick={this.toggleExpanded}>{this.props.readMoreText || 'Læs mere'}</span>
            </React.Fragment>;
    }

    private toggleExpanded = () => this.setState({ isExpanded: !this.state.isExpanded });
}

export default ReadMore;